import {
  AREA_OF_CONCERN,
  CALCULUS,
  CARIES,
  CARIES_SUBCLASSIFICATION,
  PERIAPICAL_RADIOLUCENCY,
  RADIOGRAPHIC_BONELOSS,
  RESTORATIVE_ADJACENT_LUCENCY,
} from '../constants';
import type { BoundingBoxFinding } from '../modules/annotator/types';
import { allDentition } from '../modules/odontogramV2/constants';

export const computeFindingGroups = (
  userAnnotations: any,
  systemFindings: any,
  featureFlaggedFindingTypes: any,
) => {
  const cariesSystemFindings = systemFindings
    .filter((f: any) => f.type === 'caries')
    .map((f: any) => {
      if (f.type === 'cariesbb') {
        f.type = 'caries';
        return f;
      }
      return f;
    });
  const cariesUserAnnotations = userAnnotations.filter(
    (f: any) => f.type === 'caries',
  );
  const prlSystemFindings = systemFindings.filter(
    (f: any) => f.type === PERIAPICAL_RADIOLUCENCY,
  );
  const prlUserAnnotations = userAnnotations.filter(
    (f: any) => f.type === PERIAPICAL_RADIOLUCENCY,
  );

  const rblSystemFindings = systemFindings.filter(
    (f: any) => f.type === RADIOGRAPHIC_BONELOSS,
  );
  const rblUserAnnotations = userAnnotations.filter(
    (f: any) => f.type === RADIOGRAPHIC_BONELOSS,
  );
  const areaOfConcernFindings = systemFindings.filter(
    (f: any) => f.type === AREA_OF_CONCERN,
  );
  const restorativeAdjacentLucencyFindings = systemFindings.filter(
    (f: BoundingBoxFinding) => f.type === RESTORATIVE_ADJACENT_LUCENCY,
  );

  const calculusFindings = systemFindings.filter(
    (f: any) => f.type === CALCULUS,
  );

  const cariesFindings = [...cariesSystemFindings, ...cariesUserAnnotations];

  const cariesFindingGroup = {
    type: CARIES,
    canEnabled: featureFlaggedFindingTypes[CARIES],
    findings: cariesFindings,
  };

  const prlFindings = [...prlSystemFindings, ...prlUserAnnotations];

  const prlFindingGroup = {
    type: PERIAPICAL_RADIOLUCENCY,
    canEnabled: featureFlaggedFindingTypes[PERIAPICAL_RADIOLUCENCY],
    findings: prlFindings,
  };

  const rblFindings = [...rblSystemFindings, ...rblUserAnnotations];

  const rblFindingGroup = {
    type: RADIOGRAPHIC_BONELOSS,
    canEnabled: featureFlaggedFindingTypes[RADIOGRAPHIC_BONELOSS],
    findings: rblFindings,
  };

  const calculusFindingGroup = {
    type: CALCULUS,
    canEnabled: featureFlaggedFindingTypes[CALCULUS],
    findings: calculusFindings,
  };

  const areaOfConcernFindingsGroup = {
    type: AREA_OF_CONCERN,
    canEnabled:
      featureFlaggedFindingTypes[AREA_OF_CONCERN] &&
      featureFlaggedFindingTypes[CARIES_SUBCLASSIFICATION],
    findings: areaOfConcernFindings,
  };

  const restorativeAdjacentLucencyFindingGroup = {
    type: RESTORATIVE_ADJACENT_LUCENCY,
    canEnabled: featureFlaggedFindingTypes[RESTORATIVE_ADJACENT_LUCENCY],
    findings: restorativeAdjacentLucencyFindings,
  };

  return [
    cariesFindingGroup,
    rblFindingGroup,
    prlFindingGroup,
    calculusFindingGroup,
    areaOfConcernFindingsGroup,
    restorativeAdjacentLucencyFindingGroup,
  ];
};

export const isValidToothNumber = (toothNumber: string | number) =>
  allDentition.includes(toothNumber.toString());
